import { fetcher } from "helpers/fetcher";

import { TRemoveCorpMemberReq, TRemoveCorpMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const removeCorpMember = async (payload: TRemoveCorpMemberReq) => {
  return await fetcher<TRemoveCorpMemberRes, TRemoveCorpMemberReq>(
    ENDPOINT.CORPORATION.REMOVE_CORP_MEMBER,
    {
      headers: {
        [API_HEADER.CORP_ID]: payload.idCorp,
        [API_HEADER.USER_ID]: payload.idUser,
      },
    }
  );
};

export const mutationRemoveCorpMember = async (
  payload: TRemoveCorpMemberReq
) => {
  return (await removeCorpMember(payload)).data;
};

mutationRemoveCorpMember._key = (payload: TRemoveCorpMemberReq) => [
  ENDPOINT.CORPORATION.REMOVE_CORP_MEMBER.url,
  payload,
];
